import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import template from './text.pug';

export class ColumnPinnedField extends CampaignuiBaseColumn {
  constructor({
    i18n,
  }) {
    const title = i18n.getString('ColumnName_PinnedField');

    super({
      name: 'PinnedField',
      property: 'PinnedField',
      sortable: 'PinnedField',
      title,
      type: 'string',
      bodyClasses: 'grid-column-PinnedField',
      helpId: 'pop_BA_RSA_PositionPinning',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.schemaI18n = new SchemaI18n({ i18n });
  }

  get property() {
    return {
      get: ({
        PinnedField,
      }) => PinnedField,
    };
  }

  template({ value }) {
    return template({
      text: this.schemaI18n.enum('PinnedField', value),
    });
  }
}
